import { render, staticRenderFns } from "./detailtwo.vue?vue&type=template&id=f1eab0ba&scoped=true&"
import script from "./detailtwo.vue?vue&type=script&lang=js&"
export * from "./detailtwo.vue?vue&type=script&lang=js&"
import style0 from "../orderdetail/details.css?vue&type=style&index=0&id=f1eab0ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1eab0ba",
  null
  
)

export default component.exports